import React, { useState } from 'react';
import { Button, FlexGroup, Input, useTectonTheme } from '.';
import SelectGroup, { SelectGroupProps } from './SelectGroup';
import { LithosComponent } from './LithosComponent';
import styled from '@emotion/styled';

interface SelectProps {
  groups: SelectGroupProps[];
  filterable?: boolean;
  reset?: () => void;
}

const SelectBody = styled.div`
  &:focus:focus-visible {
    outline-style: none !important; // Required to override a bad EUI pattern. We should fix this in the future, once we remove EUI.
  }
`;

const Select: LithosComponent<SelectProps> = ({ groups, filterable, reset, testId = 'select' }) => {
  const [filterQuery, setFilterQuery] = useState<string | undefined>(undefined);
  const { theme } = useTectonTheme();

  return (
    <SelectBody
      tabIndex={0}
      role="listbox"
      onKeyDown={(event) => {
        if (event.code === 'ArrowDown') {
          event.preventDefault();
        }

        if (event.code === 'ArrowUp') {
          event.preventDefault();
        }
      }}
      data-testid={testId}
    >
      <FlexGroup
        direction="column"
        padding="0"
        gapSize="2"
        css={{
          maxHeight: `${theme.v1.size['80']}px`,
          height: 'auto',
          overflow: 'hidden',
          minWidth: `${theme.v1.size['16']}px`,
          maxWidth: `${theme.v1.size['80']}px`,
        }}
      >
        {filterable && (
          <>
            <Input value={filterQuery} type="string" onChange={setFilterQuery} icon="Filters" autoFocus size="s" />
          </>
        )}
        {reset && (
          <>
            <Button type="secondary" label={'Reset'} onClick={reset} fullWidth={false} />
          </>
        )}
        <div style={{ overflow: 'auto' }}>
          {groups.map((group) => (
            <SelectGroup {...group} filterQuery={filterQuery} key={group.title} />
          ))}
        </div>
      </FlexGroup>
    </SelectBody>
  );
};

export default Select;
